export const PageIntro = ({ eyebrow, title, children, image, imageAlt = "", testId = "page-intro" }) => (
  <section className="relative overflow-hidden grain" data-testid={testId}>
    <div className={`container-site pt-14 pb-12 md:pt-20 md:pb-16 grid gap-10 ${image ? "lg:grid-cols-[1.25fr_1fr] items-center" : ""}`}>
      <div className="max-w-3xl animate-fade-up">
        {eyebrow && <p className="eyebrow mb-4">{eyebrow}</p>}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">{title}</h1>
        <div className="mt-6 text-base md:text-lg text-ink-soft max-w-2xl space-y-4">{children}</div>
      </div>
      {image && (
        <div className="relative hidden lg:block animate-fade-up [animation-delay:150ms]">
          <img src={image} alt={imageAlt} className="w-full h-[360px] object-cover rounded-[2rem]" />
          <div className="absolute -bottom-4 -left-4 h-24 w-24 rounded-full bg-sage/60 -z-10" aria-hidden="true" />
        </div>
      )}
    </div>
  </section>
);
